<div class="card-inner-main-div">
  <div class="card-main-title border-bottom">
    @if (showSegReport) {
      <h4 class="card-title">{{ 'Contribution To Exposures' | translate }}</h4>
    }
    @if (!showSegReport) {
      <h4 class="card-title-report">{{ 'Associated Task Groups' | translate }}</h4>
    }
  </div>
  <div class="tableColStyle without-borders-table">
    @if (loading) {
      <div class="comments-loader">
        <img src="assets/images/loader.gif">
      </div>
    }
    @if (!loading) {
      <div class="table-responsive">
        <table class="table table-striped" matSort matSortDisableClear (matSortChange)="sortExposureContribution($event)">
          <thead>
            <tr>
              <th mat-sort-header="taskGroupName" scope="col">
                <a>{{ 'Task Group' | translate }}</a>
              </th>
              @if (showSegReport) {
                <th mat-sort-header="taskName" scope="col">
                  <a>{{ 'Task' | translate }}</a>
                </th>
              }
              @if (showSegReport) {
                <th mat-sort-header="timeOnShiftPercent" scope="col">
                  <a>{{ 'Time on Shift %' | translate }}</a>
                </th>
              }
              @if (showSegReport) {
                <th mat-sort-header="massContributionPercent" scope="col">
                  <a>{{ 'Mass Contribution %' | translate }}</a>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (exposure of exposureContribution; track trackByIndex($index)) {
              <tr [ngClass]="{active: 0}"
                (click)="toggleTaskwithSEGPopup(exposure)">
                @if (showSegReport) {
                  <td class="" (click)="onClick(exposure)">
                    <a><span class="font-700">{{exposure?.taskGroupName}}</span></a>
                  </td>
                }
                @if (!showSegReport) {
                  <td class="" (click)="onClickReport($event, exposure)">
                    <a><span class="font-700">{{exposure?.taskGroupName}}</span></a>
                  </td>
                }
                @if (showSegReport) {
                  <td>
                    <a>{{exposure?.taskName}}</a>
                  </td>
                }
                @if (showSegReport) {
                  <td>
                    <a>
                      <div class="percentage-txt-div justify-content-between w-100">
                        <span class="percent-box sky-blue-bg"
                        [style]="{width: exposure?.timeOnShiftPercentAbs+'%'}"></span>{{exposure?.timeOnShiftPercent}}%
                      </div>
                    </a>
                  </td>
                }
                @if (showSegReport) {
                  <td>
                    <a>
                      <div class="percentage-txt-div justify-content-between w-100">
                        <span class="percent-box purple-bg"
                        [style]="{width: exposure?.massContributionPercentAbs+'%'}"></span>{{exposure?.massContributionPercent}}%
                      </div>
                    </a>
                  </td>
                }
              </tr>
            }
            @if (exposureContribution && !exposureContribution.length) {
              <tr>
                <td colspan="4" class="no-data-available with-padding">{{ 'No Data Available' | translate }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

@if (!showSegReport && selectedTask) {
  <app-exposure-by-task [show]="show" [showRep]="showRep" [showSegReport]="false" (hideSEGDetailEmit)="hideSEGDetailFn()" [segTasks]="segTasks"
    [selectedSEG]="selectedSEG" [selectedTask]="selectedTask" [selectedTaskGroup]="taskExposureContributions" (showSEGDetailEmit)="showSEGDetailFn()"
  (hideTaskSupervisorEmit)="hideTaskSupervisorFn()"></app-exposure-by-task>
}